<template>
  <v-app-bar
    height="101"
    max-height="101"
    dark
    class="navbar px-12"
    :app="$vuetify.breakpoint.mdAndUp"
  >
    <v-app-bar-nav-icon @click="handleNavIconClick()">
      <v-icon>{{ routeIsInicio ? 'mdi-menu' : 'mdi-arrow-left' }}</v-icon>
    </v-app-bar-nav-icon>

    <v-toolbar-title class="navbar__usamedic">
      <router-link :to="{name: 'Inicio'}" class="white--text text-decoration-none">
        USAMEDIC
      </router-link>
      <v-scroll-x-transition>
        <span v-if="$route.meta.appBarTitle">
          | <span class="navbar__titulo">{{ $route.meta.appBarTitle }}</span>
        </span>
      </v-scroll-x-transition>
    </v-toolbar-title>

    <v-spacer></v-spacer>
<!--    <v-btn-->
<!--      text class="ml-10"-->
<!--      exact-->
<!--    >-->
<!--      <v-img src="@/assets/icon/cart.svg" class="align-self-center" height="30" contain></v-img>-->
<!--    </v-btn>-->
    <!-- opcion de cart -->
    <!-- opcion de estadistica -->
    <v-btn
      :to="{name: 'Estadisticas'}"
      text
      exact
    >
      <v-img src="@/assets/icon/stats.svg" class="align-self-center" height="30" contain></v-img>
    </v-btn>
    <!-- opcion de estadistica -->
    <!-- opcion de usuario -->
    <p class="nombre-usuario align-self-center ml-2 text-truncate">
      <span>
        {{ nombreUsuario }}
      </span>
    </p>
    <v-btn fab height="45px" width="45px" text class="ml-4" :to="{name:'Perfil'}">
      <v-img
        class="white rounded-circle border-solid-4 mr-0"
        :src="fotoPerfil"
        alt="Foto Perfil Usuario"
        height="45px"
        width="45px"
        :to="{name:'Perfil'}"
      />
    </v-btn>
    <!-- opcion de usuario -->
  </v-app-bar>

</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'NavBar',
  // props: {
  //   navbarcompleto: Boolean,
  //   nombreUsuario: String,
  //   titulo: String,
  //   picture_src: String,
  //   goto: String,
  //   gotoLink: Boolean,
  //   prefijoUsamedic: String
  // },

  data () {
    return {
      clasesModal: false
    }
  },
  computed: {
    ...mapGetters('perfil', ['fotoPerfil', 'nombreUsuario']),
    ...mapState(['drawer']),
    routeIsInicio () {
      return this.$route.name === 'Inicio'
    }
  },
  methods: {
    ...mapMutations(['SET_DRAWER']),
    handleNavIconClick () {
      if (this.routeIsInicio) {
        this.SET_DRAWER(!this.drawer)
      } else {
        this.goBack()
      }
    },
    goBack () {
      // console.log(this.$router)
      if (this.$route.meta.backLinkTo) {
        this.$router.push(this.$route.meta.backLinkTo)
      } else {
        if (localStorage.getItem('PREVIOUS_PAGE')) {
          this.$router.go(-1)
        } else {
          this.$router.push({ name: 'Inicio' })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.navbar {
  height: 101px;
  background: linear-gradient(90deg, #1fc1d0, #0583da);

  &__menu {
    margin: auto 0 auto 80px;
    cursor: pointer;
  }

  &__usamedic {
    margin: auto 25px;
    color: white;
    word-spacing: 24px;
    line-height: 30px;
    font-size: 20px;
    font-weight: 700;
  }

  &__titulo {
    word-spacing: 5px;
  }

  &__logo {
    margin: auto 0px;
    margin-right: 100px;
    margin-left: auto;
    max-width: 50px;
  }

  &__options {
    margin: auto 0px;
    margin-right: 80px;
    margin-left: auto;
  }
}

.button {
  border: none;
  background-color: transparent;
  opacity: 1;
}

.nombre-usuario {
  font-size: 20px;
  font-weight: 500;
  color: white;
  margin: auto 0;
  width: 160px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
